import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, Coffee, Palette, Heart, Sparkles, HandHeart } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
export function OverOns() {
  return <div data-id="element-1075">
      {/* Hero */}
      <section className="relative bg-gray-100 border-b border-gray-300" data-id="element-1076">
        <div className="relative h-[360px] md:h-[440px] overflow-hidden" data-id="element-1077">
          <div className="absolute inset-0 border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-100" data-id="element-1078">
            <span className="text-gray-400 text-lg" data-id="element-1079">
              De Maekerij sfeerbeeld
            </span>
          </div>
          <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4 pointer-events-none" data-id="element-1080">
            <div className="bg-white/90 border border-gray-200 rounded-lg px-8 py-8 md:px-12 md:py-10 text-center pointer-events-auto" data-id="element-1081">
              <h1 className="text-4xl md:text-5xl font-bold" data-id="element-1082">
                Over De Maekerij
              </h1>
            </div>
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4" data-id="element-1083">
        {/* Mission */}
        <section className="py-16 max-w-3xl mx-auto" data-id="element-1084">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center" data-id="element-1085">
            Waarom De Maekerij?
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-1086">
            De Maekerij is een plek waar vrouwen samenkomen om te creëren, te
            leren en elkaar te ontmoeten. We geloven dat creativiteit verbindt —
            en dat verbinding de basis is van een sterk netwerk.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-1087">
            In een wereld die steeds sneller draait, willen we een plek bieden
            waar je even tot rust kunt komen, iets met je handen kunt maken en
            tegelijk nieuwe mensen leerts kennen. Of je nu komt voor een
            workshop, een kop koffie of een gezellige avond in een van onze
            maekerscafés — je bent welkom zoals je bent.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1088">
            Ons doel? Vrouwen aanmoedigen om deel te nemen, zich te engageren en
            samen een netwerk te vormen dat verder reikt dan de muren van De
            Maekerij.
          </p>
        </section>

        {/* Three pillars */}
        <section className="pb-16" data-id="element-1089">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-1090">
            Wat we doen
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-1091">
            <Card variant="outlined" data-id="element-1092">
              <CardContent data-id="element-1093">
                <div className="border border-dashed border-gray-300 h-40 -mx-4 -mt-4 mb-6 flex items-center justify-center bg-gray-100 rounded-t-lg" data-id="element-1094">
                  <Palette size={32} className="text-gray-300" data-id="element-1095" />
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1096">Workshops</h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-1097">
                  Van keramiek en textiel tot grafiek en houtbewerking — onze
                  workshops zijn de perfecte manier om iets nieuws te leren en
                  tegelijk andere vrouwen te ontmoeten. Alle niveaus zijn
                  welkom.
                </p>
                <Link to="/workshops" className="text-sm font-medium text-gray-700 hover:underline inline-flex items-center" data-id="element-1098">
                  Bekijk workshops <ArrowRight size={14} className="ml-1" data-id="element-1099" />
                </Link>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-1100">
              <CardContent data-id="element-1101">
                <div className="border border-dashed border-gray-300 h-40 -mx-4 -mt-4 mb-6 flex items-center justify-center bg-gray-100 rounded-t-lg" data-id="element-1102">
                  <Coffee size={32} className="text-gray-300" data-id="element-1103" />
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1104">Koffiebar</h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-1105">
                  Het kloppende hart van De Maekerij. Een gezellige plek om af
                  te spreken, te werken of gewoon te genieten van een goede kop
                  koffie. Vrij toegankelijk voor iedereen.
                </p>
                <Link to="/koffiebar" className="text-sm font-medium text-gray-700 hover:underline inline-flex items-center" data-id="element-1106">
                  Ontdek de koffiebar <ArrowRight size={14} className="ml-1" data-id="element-1107" />
                </Link>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-1108">
              <CardContent data-id="element-1109">
                <div className="border border-dashed border-gray-300 h-40 -mx-4 -mt-4 mb-6 flex items-center justify-center bg-gray-100 rounded-t-lg" data-id="element-1110">
                  <Users size={32} className="text-gray-300" data-id="element-1111" />
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1112">Maekerscafés</h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-1113">
                  Onze maekerscafés zijn het hart van ons netwerk. Informele
                  bijeenkomsten rond een creatief thema waar je samen werkt,
                  deelt en verbindt. Gratis en laagdrempelig.
                </p>
                <Link to="/maekerscafés" className="text-sm font-medium text-gray-700 hover:underline inline-flex items-center" data-id="element-1114">
                  Ontdek maekerscafés <ArrowRight size={14} className="ml-1" data-id="element-1115" />
                </Link>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* The journey / engagement funnel — subtle narrative */}
        <section className="pb-16" data-id="element-1116">
          <div className="max-w-3xl mx-auto bg-gray-50 border border-gray-200 rounded-lg p-8 md:p-12" data-id="element-1117">
            <h2 className="text-xl md:text-2xl font-bold mb-6 text-center" data-id="element-1118">
              Wat kan jij allemaal beleven bij De Maekerij
            </h2>
            <div className="space-y-6" data-id="element-1119">
              <div className="flex items-start" data-id="element-1120">
                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1121">
                  <Sparkles size={16} className="text-gray-600" data-id="element-1122" />
                </div>
                <div className="ml-4" data-id="element-1123">
                  <h3 className="font-bold mb-1" data-id="element-1124">Ontdek</h3>
                  <p className="text-sm text-gray-600" data-id="element-1125">
                    Volg een workshop die je aanspreekt en ontdek je creatieve
                    kant. Geen ervaring nodig — gewoon nieuwsgierigheid.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1126">
                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1127">
                  <Users size={16} className="text-gray-600" data-id="element-1128" />
                </div>
                <div className="ml-4" data-id="element-1129">
                  <h3 className="font-bold mb-1" data-id="element-1130">Verbind</h3>
                  <p className="text-sm text-gray-600" data-id="element-1131">
                    Kom langs in de koffiebar of sluit aan bij een maekerscafé.
                    Leer andere vrouwen kennen die dezelfde interesses delen.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1132">
                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1133">
                  <HandHeart size={16} className="text-gray-600" data-id="element-1134" />
                </div>
                <div className="ml-4" data-id="element-1135">
                  <h3 className="font-bold mb-1" data-id="element-1136">Engageer</h3>
                  <p className="text-sm text-gray-600" data-id="element-1137">
                    Word een vaste bezoeker, deel je kennis en bouw mee aan een
                    warm netwerk van creatieve vrouwen in jouw buurt.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Femma section — link to dedicated page */}
        <section className="pb-16" data-id="element-1138">
          <div className="max-w-3xl mx-auto" data-id="element-1139">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-1140">
              <div className="md:w-1/3 border-2 border-dashed border-gray-300 h-48 w-full flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0" data-id="element-1141">
                <span className="text-gray-400 text-sm" data-id="element-1142">Femma logo</span>
              </div>
              <div className="md:w-2/3" data-id="element-1143">
                <h2 className="text-xl font-bold mb-3" data-id="element-1144">Onderdeel van Femma</h2>
                <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-1145">
                  De Maekerij is een initiatief van Femma, een van de grootste
                  sociaal-culturele vrouwenbewegingen in Vlaanderen. Femma
                  brengt vrouwen samen en zet zich in voor verbinding,
                  gelijkheid en solidariteit.
                </p>
                <Link to="/femma" className="text-sm font-medium text-gray-700 hover:underline inline-flex items-center" data-id="element-1146">
                  Meer over Femma <ArrowRight size={14} className="ml-1" data-id="element-1147" />
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Subtle Femma membership mention — very low-key */}
        <section className="mb-12" data-id="element-1148">
          <div className="max-w-3xl mx-auto" data-id="element-1149">
            <div className="border border-gray-200 rounded-lg p-6 bg-white" data-id="element-1150">
              <div className="flex items-start" data-id="element-1151">
                <Heart size={20} className="text-gray-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-1152" />
                <div data-id="element-1153">
                  <p className="text-sm text-gray-600" data-id="element-1154">
                    Wist je dat je ook lid kunt worden van Femma? Als lid steun
                    je onze werking en krijg je toegang tot extra activiteiten
                    en voordelen.{' '}
                    <a href="https://www.femma.be" target="_blank" rel="noopener noreferrer" className="text-gray-700 font-medium hover:underline" data-id="element-1155">
                      Meer info op femma.be →
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
}